import { Pipe, PipeTransform } from '@angular/core';
import { IButtonConfig } from '../../../../modules/tasks/model/types';

/**
 * Computes the per-row button state (hint/disabled/icon/cssClass) for the DataGrid
 * buttons template without mutating the shared `datagridButtons` array.
 *
 * Replaces `DataGridComponent.getButtons()`, which mutated `this.datagridButtons`
 * in-place and returned the same array reference, causing every row to display the
 * last-evaluated row's button state and triggering unnecessary DxButtonComponent
 * change detection cycles.
 */
@Pipe({ name: 'gridButtons', pure: true, standalone: false })
export class GridButtonsPipe implements PipeTransform {
  transform(
    rowData: any,
    buttons: IButtonConfig[] | null | undefined,
    isDisabled: ((id: string, rd: any) => boolean) | undefined,
    getHint: ((btn: IButtonConfig, rd: any) => string) | undefined,
    getIcon: ((btn: IButtonConfig, rd: any) => string) | undefined,
    getBtnClass: ((btn: IButtonConfig, rd: any) => string) | undefined,
    isVisible?: (id: string, rd: any) => boolean
  ): IButtonConfig[] {
    if (!buttons) return [];
    return buttons.filter(button => !isVisible || isVisible(button.id, rowData)).map(button => ({
      ...button,
      hint: getHint ? getHint(button, rowData) : button.hint,
      disabled: isDisabled ? isDisabled(button.id, rowData) : button.disabled,
      icon: getIcon ? getIcon(button, rowData) : button.icon,
      cssClass: getBtnClass ? getBtnClass(button, rowData) : button.cssClass,
    }));
  }
}
